import React from "react";
import MarketingShell, { Section } from "@/components/MarketingShell";

export default function Privacy() {
  return (
    <MarketingShell title="Privacy Policy" subtitle="Last updated June 2026">
      <p>This Privacy Policy explains how Local CiteHub ("we", "us") collects, uses, and protects your information when you use our citation-management service.</p>

      <Section heading="Information we collect">
        <ul className="list-disc list-inside space-y-1">
          <li><strong>Account data:</strong> your name, email address, and password (stored securely, hashed).</li>
          <li><strong>Business data:</strong> the business listings you add (name, address, phone, website, hours, description, logo).</li>
          <li><strong>Payment data:</strong> processed by Stripe. We never store your full card details.</li>
          <li><strong>Usage data:</strong> basic analytics to improve the product.</li>
        </ul>
      </Section>

      <Section heading="How we use it">
        <p>We use your information to provide the service, generate listing content, process subscriptions, send transactional emails, and provide support. We do not sell your personal information.</p>
      </Section>

      <Section heading="Data sharing">
        <p>We share data only with service providers needed to run Local CiteHub (e.g. Stripe for payments, our cloud hosting and storage providers). The business information you choose to publish is submitted to third-party directories at your direction.</p>
      </Section>

      <Section heading="Data retention & your rights">
        <p>You can edit or delete your businesses at any time from your dashboard. To request deletion of your account and associated data, contact us via the Contact page. We retain data as required to provide the service and meet legal obligations.</p>
      </Section>

      <Section heading="Contact">
        <p>Questions about this policy? Reach us through the <a href="/contact" className="text-[#0055FF] font-semibold hover:underline">Contact page</a>.</p>
      </Section>
    </MarketingShell>
  );
}
